import { render, staticRenderFns } from "./CreateOrganisation.vue?vue&type=template&id=5a83ba20"
import script from "./CreateOrganisation.vue?vue&type=script&lang=ts"
export * from "./CreateOrganisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports